module.exports = __webpack_public_path__ + "static/media/BREW.f2072956.png";